import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  filter: {
    companyId: number
    clientIds: Array<number>
    cameraIds: Array<number>
  }
}

export default function useDashboardCameras({filter}: Props) {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_CAMERAS, filter],
    queryFn: async () => (await api.reports.camerasReports({filter})).data.data,
  })

  return query
}
